import React, { useEffect } from 'react';
import useReactRouter from 'use-react-router';
import { useSelector } from 'react-redux';
import { autoIncrementedName } from '../../helpers/name-autoincrement';
import {
  DEFAULT_ENTITY_NAME as LANDING_PAGE_ENTITY_NAME,
  getDefaultHeading,
  getDefaultText,
  DEFAULT_BG_COLOR,
} from '../../../editor/features/landingPages/constants/constants';
import LandingPageModel from '@mm/state/model/LandingPageModel';
import { useLandingPageCRUDActions } from '@mm/state/actions/LandingPageCRUDActions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import { selectLandingPages } from '@mm/state/selectors/landingPageSelectors';

type Props = {
  botId: number;
  fbPageId?: number;
  botRoute: string;
  fbPageName?: string | null;
};

export const useCreateLandingPage = () => {
  const { history } = useReactRouter();

  const botId = useSelector(activeChatbotIdSelector);
  const fbPage = useSelector(activeFacebookPageSelector);

  const landingPages = useSelector(selectLandingPages);
  const landingPageCRUDActions = useLandingPageCRUDActions();

  const createLandingPage = async () => {
    if (fbPage && fbPage.name && fbPage.id) {
      const name = autoIncrementedName(
        LANDING_PAGE_ENTITY_NAME,
        landingPages.map((lP: LandingPageModel) => lP.name),
      );
      const heading = getDefaultHeading(fbPage.name);
      const text = getDefaultText(fbPage.name);

      const landingPage = {
        name,
        heading,
        text,
        color: DEFAULT_BG_COLOR,
      };

      const createdLandingPage = await landingPageCRUDActions.create(
        botId,
        landingPage,
        fbPage.id,
      );
      if (createdLandingPage) {
        const path = BotBuilderRoutes.landingPagesEdit.getLink({
          chatbotId: botId,
          landingPageId: createdLandingPage.id,
        });
        history.push(path);
      }
    }
  };
  return {
    createLandingPage,
  };
};

const CreateRemoteLandingPage = (props: Props) => {
  const { botId, fbPageId, fbPageName } = props;

  const { createLandingPage } = useCreateLandingPage();

  useEffect(() => {
    if (botId && fbPageId) {
      createLandingPage();
    }
  }, [botId, fbPageName, fbPageId]);

  return <div />;
};

export default CreateRemoteLandingPage;
